class CommsIdentityCache {
  constructor() {
    this.cacheKey = 'commsIdentityCache';
    this.cacheDuration = 60 * 60 * 1000; // 1 hour
  }

  // Get cached { clients, coaches } maps if valid
  get() {
    try {
      const cached = localStorage.getItem(this.cacheKey);
      if (!cached) return null;

      const { data, timestamp } = JSON.parse(cached);
      const age = Date.now() - timestamp;

      if (age < this.cacheDuration) {
        return data;
      } else {
        this.clear();
        return null;
      }
    } catch (e) {
      console.error('Failed to get comms identity cache:', e);
      this.clear();
      return null;
    }
  }

  // Set { clients, coaches } maps in cache with current timestamp
  set(data) {
    try {
      const cacheObject = {
        data,
        timestamp: Date.now(),
      };
      localStorage.setItem(this.cacheKey, JSON.stringify(cacheObject));
    } catch (e) {
      console.error('Failed to set comms identity cache:', e);
      if (e?.name === 'QuotaExceededError') {
        this.clear();
      }
    }
  }

  // Check if cache is valid
  isValid() {
    try {
      const cached = localStorage.getItem(this.cacheKey);
      if (!cached) return false;

      const { timestamp } = JSON.parse(cached);
      const age = Date.now() - timestamp;

      return age < this.cacheDuration;
    } catch (e) {
      return false;
    }
  }

  // Clear cache
  clear() {
    try {
      localStorage.removeItem(this.cacheKey);
    } catch (e) {
      console.error('Failed to clear comms identity cache:', e);
    }
  }
}

// Export singleton instance
export const commsIdentityCache = new CommsIdentityCache();
